import React, { useEffect, Suspense } from 'react';
import { Flex, FlexProps } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import { useAppSelector } from '../../../common/hooks/redux';
import { useDispatch } from 'react-redux';
import { Sidebar } from '../../navigation';
import { Header } from '../Header';
import AppFallback from '../../components/AppFallback/AppFallback';
import './MainLayout.scss';

/**
 * MainLayout: presentation layer (DDD UI).
 * Compose header + sidebar + outlet; Suspense only around Outlet so shell stays mounted on lazy page loads.
 */
const MainLayout: React.FC = () => {
  const dispatch = useDispatch();
  const userRole = useAppSelector(
    (state: any) => state.authorization?.user?.role || 'none',
  );
  const user = useAppSelector((state: any) => state.authorization?.user);

  useEffect(() => {
    if (userRole !== 'none') {
      // Reserved: post-login side effects (websocket, feature flags, etc.)
    }
  }, [userRole, dispatch, user?.id]);

  return (
    <Flex id='main' className='dashboard' direction='column' minH='100vh'>
      <Header showLanguageSelector />
      <Flex className='dashboard__body' flex={1}>
        <Sidebar />
        <Flex {...getWrapStyle()} className='dashboard__content' flex={1}>
          <Suspense fallback={<AppFallback />}>
            <Outlet />
          </Suspense>
        </Flex>
      </Flex>
    </Flex>
  );
};

/** Scroll container styles for the main content column */
const getWrapStyle = (): FlexProps =>
  ({
    w: 'full',
    flex: 1,
    overflowY: 'auto',
    overflowX: 'hidden',
    sx: {
      '&::-webkit-scrollbar': {
        width: '8px',
        height: '5px',
        borderRadius: '15px',
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
      },
      '&::-webkit-scrollbar-thumb': {
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        borderRadius: '15px',
      },
    },
  }) as FlexProps;

export default MainLayout;
